import React, { useState, useEffect } from 'react'; 
import 'aos/dist/aos.css';
import './CarSlider.css';
import { FaStar, FaGasPump, FaCogs, FaUsers, FaSuitcase } from 'react-icons/fa';
import { Container, Row, Col, Card, Button, Carousel } from 'react-bootstrap';

const cars = [
  {
    name: 'Maruti Swift Dzire',
    type: 'Sedan',
    price: '₹ /Hour',
    info: 'Parking-Toll Extra',
    rating: 4.5,
    fuel: 'CNG',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/Dzire.png'
  },
  {
    name: 'Hyundai Xcent',
    type: 'Sedan',
    price: '₹ /Hour',
    info: 'Toll Parking Extra',
    rating: 4.5,
    fuel: 'CNG',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/Acent.png'
  },
  {
    name: 'Maruti Suzuki Swift',
    type: 'Hatch Back',
    price: '₹ 90/Hour',
    info: 'Pickup from Uttar Pradesh, India',
    rating: 4.5,
    fuel: 'Petrol',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/swift.png'
  },
  {
    name: 'Maruti Suzuki Ciaz',
    type: 'Sedan',
    price: '₹ 230/Hour',
    info: 'Pickup from Uttar Pradesh, India',
    rating: 4.5,
    fuel: 'Petrol',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/Ciazcar.png'
  },
  {
    name: 'Hyundai Creata',
    type: 'SUV',
    price: '₹ /Hour',
    info: 'Parking-Toll Extra',
    rating: 4.5,
    fuel: 'CNG',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/creata.png'
  },
  {
    name: 'Swift',
    type: 'Sedan',
    price: '₹ /Hour',
    info: 'Toll Parking Extra',
    rating: 4.5,
    fuel: 'CNG',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/SwiftCar.png'
  },
  {
    name: 'Maruti Suzuki Swift',
    type: 'Hatch Back',
    price: '₹ 90/Hour',
    info: 'Pickup from Uttar Pradesh, India',
    rating: 4.5,
    fuel: 'Petrol',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/swift.png'
  },
  {
    name: 'Maruti Suzuki Ciaz',
    type: 'Sedan',
    price: '₹ 230/Hour',
    info: 'Pickup from Uttar Pradesh, India',
    rating: 4.5,
    fuel: 'Petrol',
    transmission: 'Manual',
    seats: '5 Seater',
    baggage: '2 Baggage',
    image: '/assets/ciaz.png'
  }
];

const CarSlider = () => {
  const [index, setIndex] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const itemsPerPage = 4;

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    handleResize(); // Initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleNext = () => {
    setIndex((prev) => (prev + 1 + itemsPerPage > cars.length ? 0 : prev + 1));
  };

  const handlePrev = () => {
    setIndex((prev) => (prev - 1 < 0 ? cars.length - itemsPerPage : prev - 1));
  };

  const renderCarCard = (car, i) => (
    <Card className="car-card pb-2" key={i}>
      <div className="position-relative text-center p-3">
        <Card.Img variant="top" src={car.image} className="img-fluid car-image" />
        <div className="rating-badge"><FaStar className="me-1" /> {car.rating}</div>
        <div className="price-tag">{car.price}</div>
      </div>
      <Card.Body>
        <Card.Title className="fw-bold fontroboto">{car.name}</Card.Title>
        <Card.Text className="text-muted mb-1">{car.type}</Card.Text>
        <Card.Text className="text-muted small">{car.info}</Card.Text>
        <div className="d-flex justify-content-between text-muted mt-3 car-features">
          <small><FaGasPump className="me-1" /> {car.fuel}</small>
          <small><FaCogs className="me-1" /> {car.transmission}</small>
          <small><FaUsers className="me-1" /> {car.seats}</small>
          <small><FaSuitcase className="me-1" /> {car.baggage}</small>
        </div>
        <Button variant="dark" size="sm" className="mt-3 w-100">Book Now</Button>
      </Card.Body>
    </Card>
  );

  return (
    <Container className="car-slider mt-5">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div className='fontgeorgio'>
          <h6 className="text-warning fw-bold">Your Best Cars</h6>
          <h2 className="fw-bold">Hire Popular Rental Cars</h2>
        </div>
      </div>

      {isMobile ? (
        <Carousel
          activeIndex={index}
          onSelect={(selectedIndex) => setIndex(selectedIndex)}
          indicators={false}
        >
          {cars.map((car, i) => (
            <Carousel.Item key={i}>
              {renderCarCard(car, i)}
            </Carousel.Item>
          ))}
        </Carousel>
      ) : (
        <Row>
          {cars.slice(index, index + itemsPerPage).map((car, i) => (
            <Col key={i} lg={3} md={6} sm={12} className="mb-4">
              {renderCarCard(car, i)}
            </Col>
          ))}
        </Row>
      )}

      {isMobile && (
        <div className="carousel-nav">
          <div className="carousel-nav-item" onClick={handlePrev}></div>
          <div className="carousel-nav-item" onClick={handleNext}></div>
        </div>
      )}
    </Container>
  );
};

export default CarSlider;